import { client } from '@/utils/apiClient';

import getI18nContentData from '../data/getI18nContent';
import getPaymentMethodsData from '../data/getPaymentMethods';



export async function getI18nContent(params?: any) {
  // 目前模拟数据返回

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (Math.random() > 0.01) {
        resolve(getI18nContentData);
      } else {
        reject(new Error('Error Data'));
      }
    }, 1000);
  });
};

// GetPaymentMethodsDocument

export async function GetPaymentMethodsDocument(params?: any) {
  // 目前模拟数据返回
  const langKey = params?.variables?.langKey;

  // 使用 params 配置对象，自动转为 ?langKey=xxx
  const response = await client.get('/kyc/api/payment-methods', {
    params: {
      langKey,           // ← 这里会变成 URL 查询参数 ?langKey=zh
      // 如果还有其他参数，可以继续添加
      // timestamp: Date.now(),
    },
  });

  return response;

 // return   client.get('/kyc/api/payment-methods');


/*   return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (Math.random() > 0.01) {
        resolve(getPaymentMethodsData);
      } else {
        reject(new Error('Error Data'));
      }
    }, 1000);
  }); */
};

